import React from 'react'
import PropTypes from 'prop-types'

import { ConfirmationDialog } from 'components'

const ActiveAuditConflictDialog = ({
  open,
  setOpen,
  onConfirm,
  loading = false,
}) => (
  <ConfirmationDialog
    open={open}
    setOpen={setOpen}
    text="Existe uma auditoria em andamento cujo prazo abrange a data de início da automação. Ao confirmar, essa auditoria será finalizada para o início da automação. Deseja continuar?"
    textButton="Confirmar"
    textButtonCancel="Cancelar"
    actionAcceptButton={onConfirm}
    loading={loading}
  />
)

ActiveAuditConflictDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default ActiveAuditConflictDialog
